module.exports = function insertStyleIntoWidgetShadow(styleElement) {
  let host = document.getElementById("smm-auth-widget-host")
  if (!host) {
    host = document.createElement("div")
    host.id = "smm-auth-widget-host"
    document.body.appendChild(host)
  }

  const shadow = host.shadowRoot || host.attachShadow({ mode: "open" })
  shadow.appendChild(styleElement)
}
